export default __webpack_public_path__ + "static/search-dcd9e019399b3dcadd3c77f022d211f6.png";